const Flickity = require('flickity');

export default () => {

    const grids = document.querySelectorAll('[data-news-grid]');
    let sliders = [];

    const init = () => {
        for (const grid of grids) {
            const flickity = new Flickity(grid, {
                cellAlign: 'left',
                contain: true,
                prevNextButtons: false,
                pageDots: true,
                autoPlay: 5000
            });
            sliders.push(flickity);
        }
    }

    const destroy = () => {
        if (sliders.length) {
            for (const slider of sliders) {
                slider.destroy();
            }
        }
        sliders = [];
    }

    const check = () => {
        if (window.innerWidth < 768) {
            init();
        } else {
            destroy();
        }
    }


    if (grids.length) {
        check();
        window.addEventListener('resize', () => {
            check();
        });
    }

}
